export default __webpack_public_path__ + "static/news-section-food-image-dc529b3ce6a2a59f2e5d117e31d5ddb5.webp";